module.exports = __webpack_public_path__ + "img/Ident-Process-4.1ab01784.png";